import { useEffect, useRef, useState } from "react";
import AsyncSelect from 'react-select/async';

import { components } from "react-select";

import classes from './SelectWithLabel.module.css'
import { generalAsyncSearch } from "../../lib/fetchApi";
import { formatAsyncSearchOption } from "../../lib/lawFirmSearchOptions";
import { LawFirmAsyncOption } from "./LawFirmAsyncSelectComponents";
import { useDispatch, useSelector } from "react-redux";
import { attorneyActions } from "../../store/attorneys";
import { useCanEditArchived } from "../../lib/usersPermissions";


const NoOptionsMessage = props => {
    return (
      <components.NoOptionsMessage {...props}>
        <span className="custom-react-select-async-message">Start Typing to search</span> 
      </components.NoOptionsMessage>
    );
  };

const defaultSelectComponents = { NoOptionsMessage }
const lawFirmSelectComponents = { NoOptionsMessage, Option: LawFirmAsyncOption }

const selectControlStyles = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: base => ({
        ...base,
        minHeight: 'unset',
        height: '100%',
        alignItems: 'center',
    }),
    valueContainer: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
        height: '100%',
    }),
    indicatorsContainer: base => ({
        ...base,
        height: '100%',
        alignSelf: 'center',
        alignItems: 'center',
    }),
    dropdownIndicator: base => ({
        ...base,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
    }),
}

const lawFirmSelectStyles = {
    ...selectControlStyles,
    menu: base => ({ ...base, minWidth: 280 }),
}

const LAW_FIRM_SEARCH_DEBOUNCE_MS = 400

const SelectWithLabelAsync = ({icon, label, minWidth, noMinWidth, action, path, maxWidth, isDisabled }) => {
    const ref = useRef(null)
    const dispatch = useDispatch()
    const abortRef = useRef(null)
    const debounceRef = useRef(null)
    const pendingResolveRef = useRef(null)

    const [isfocused, setIsFocused] = useState(false)


    const userToken = useSelector(state => state.user.token)
    const clearSelect = useSelector(state => state.attorney.clearAsyncResults)

    const isLawFirmPath = path === 'law-firms'


    const changeHandler = (value) => {
        setIsFocused(true)
        if (action && value) {
            value.path = path
            action(value)
        }  
    }

    

    const foucsHandler = () => {
        setIsFocused(true)
    }

    const blurHandler = (e) => {        
        // setIsFocused(false)
        // if (selected == undefined && !selectValue) {
        //     setIsFocused(false)
        // }         
    }

    useEffect(() => {
        if (clearSelect && ref) {
            ref.current.clearValue()
            ref.current.blur()
            setIsFocused(false)
            dispatch(attorneyActions.setClearAsyncResults(false))
        }
    }, [clearSelect])

    useEffect(() => {
        return () => {
            if (debounceRef.current) {
                clearTimeout(debounceRef.current)
            }
            if (abortRef.current) {
                abortRef.current.abort()
            }
            if (pendingResolveRef.current) {
                pendingResolveRef.current([])
                pendingResolveRef.current = null
            }
        }
    }, [])


    const promiseOptions = (inputValue) => new Promise((resolve) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }
        if (abortRef.current) {
            abortRef.current.abort()
            abortRef.current = null
        }
        if (pendingResolveRef.current) {
            pendingResolveRef.current([])
            pendingResolveRef.current = null
        }
        pendingResolveRef.current = resolve

        const runSearch = async () => {
            const controller = new AbortController()
            abortRef.current = controller
            try {
                let values = []
                const searchedData = await generalAsyncSearch(
                    userToken,
                    path,
                    inputValue,
                    controller.signal
                )
                if (controller.signal.aborted) {
                    resolve([])
                    return
                }
                if (Array.isArray(searchedData) && searchedData.length) {
                    searchedData.forEach(element => {
                        values.push(formatAsyncSearchOption(element, path))
                    })
                }
                resolve(values)
            } catch {
                resolve([])
            } finally {
                if (pendingResolveRef.current === resolve) {
                    pendingResolveRef.current = null
                }
            }
        }

        if (isLawFirmPath) {
            debounceRef.current = setTimeout(runSearch, LAW_FIRM_SEARCH_DEBOUNCE_MS)
        } else {
            runSearch()
        }
    });

    let masterDisable = useCanEditArchived()

    return <div className={`select-container-header_bk ${classes.select_container} ${noMinWidth ? 'select_with_no_min_width' : ''}`} style={{minWidth: minWidth, maxWidth: maxWidth}}>
        {icon && <div className={classes.icon}>
            <i className={icon}></i>
        </div>}
        <div className={`${classes.action} ${isfocused ? `${classes.focused} select-focused` : ''}`}>
            {label && <span className={classes.label}>{label}</span>}

            <div className={classes.select_wrapper}>
                <AsyncSelect
                        ref={ref}                    
                        classNamePrefix="select_filter"
                        cacheOptions={!isLawFirmPath}
                        loadOptions={promiseOptions}
                        defaultOptions={false}
                        onChange={changeHandler}
                        onFocus={foucsHandler}
                        onBlur={blurHandler}
                        menuPortalTarget={document.body} 
                        styles={isLawFirmPath ? lawFirmSelectStyles : selectControlStyles}
                        components={isLawFirmPath ? lawFirmSelectComponents : defaultSelectComponents}
                        isDisabled={isDisabled || masterDisable}
                    />
            </div>
        </div>
    </div>
}

export default SelectWithLabelAsync
